import { useTranslation } from 'react-i18next';

import Render from 'components/render';
import SecurityTabs from 'components/security/twoFactorAuth/securityTabs/securityTabs';
import { selectIsMfaEnabled } from 'selectors/account';
import { useAppSelector } from 'storeHooks';

import styles from '../header.module.scss';

const MfaSettingsHeader = () => {
  const isMfaEnabled = useAppSelector(selectIsMfaEnabled);
  const { t } = useTranslation(['account']);

  return (
    <Render when={isMfaEnabled} else={<SecurityTabs />}>
      <span className={styles.headerText}>
        {`${t('account:disable')} ${t('account:2faAuth')}`}
      </span>
    </Render>
  );
};

export default MfaSettingsHeader;
